import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import { GOAL_STATUS_LABELS, GOAL_STATUS_COLORS, NO_CURRENT_GOAL_LABEL } from "../goals.constants";

// Explicit tones (not the theme's light brand colours, which are too pale as
// text): dark readable text, a light tint behind it, and a stronger dot.
const TONES = {
  success: { text: "#0e7a2b", bg: "#e4f6e8", dot: "#17ad37" },
  warning: { text: "#946200", bg: "#fff4d6", dot: "#f2b705" },
  error: { text: "#c01616", bg: "#fde7e7", dot: "#ea0606" },
  info: { text: "#0b7c99", bg: "#e0f5fb", dot: "#17c1e8" },
  secondary: { text: "#4b5a73", bg: "#eef0f4", dot: "#8392ab" },
};

// Small soft-tinted pill (tinted background, dark text + dot) used for a goal
// period's status everywhere. No `status` renders the "no goals set up" pill in
// the error tone, matching the red Set Goals action beside it.
function GoalStatusChip({ status }) {
  const tone = TONES[status ? GOAL_STATUS_COLORS[status] : "error"] || TONES.secondary;
  const label = status ? GOAL_STATUS_LABELS[status] || status : NO_CURRENT_GOAL_LABEL;

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        height: 22,
        borderRadius: "11px",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.2,
        color: tone.text,
        backgroundColor: tone.bg,
        "& .MuiChip-label": { px: 1.25, display: "flex", alignItems: "center" },
        "& .MuiChip-label::before": {
          content: '""',
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: tone.dot,
          marginRight: "6px",
        },
      }}
    />
  );
}

GoalStatusChip.defaultProps = { status: null };
GoalStatusChip.propTypes = { status: PropTypes.string };

export default GoalStatusChip;
